import { useState } from 'react'

const usePosition = () => {
  let [position, setPosition] = useState(0)

  return { position, setPosition }
}

export default usePosition
